import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function PlusIcon({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox='-2 -2 20 20'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.49194 0.410124C8.44961 0.176875 8.24546 0 8 0C7.72386 0 7.5 0.223858 7.5 0.5V7.5H0.5L0.410124 7.50806C0.176875 7.55039 0 7.75454 0 8C0 8.27614 0.223858 8.5 0.5 8.5H7.5V15.5L7.50806 15.5899C7.55039 15.8231 7.75454 16 8 16C8.27614 16 8.5 15.7761 8.5 15.5V8.5H15.5L15.5899 8.49194C15.8231 8.44961 16 8.24546 16 8C16 7.72386 15.7761 7.5 15.5 7.5H8.5V0.5L8.49194 0.410124Z'
        />
      </g>
    </svg>
  );
}
